import React from "react";
import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
} from "lucide-react";
import Logo from "../ui/Logo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-4">
            <Link to="/" aria-label="PSA Home">
              <Logo className="h-12 w-auto" light />
            </Link>
            <p className="text-gray-300 mt-4 max-w-xs">
              Professional Tax, VAT, RJSC, BIDA and business consultancy
              services tailored to meet your unique needs.
            </p>
            <div className="flex space-x-4 pt-2">
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-psa-gold-400">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Our Services
                </Link>
              </li>
              <li>
                <Link
                  to="/team"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Our Team
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Resources
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-psa-gold-400">
              Services
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/services#taxation"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Taxation
                </Link>
              </li>
              <li>
                <Link
                  to="/services#vat"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Value Added Tax (VAT)
                </Link>
              </li>
              <li>
                <Link
                  to="/services#rjsc"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  RJSC Related Work
                </Link>
              </li>
              <li>
                <Link
                  to="/services#bida"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  BIDA Related Work
                </Link>
              </li>

              <li>
                <Link
                  to="/services#accounting"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Accounting Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/services#company"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  Company Matters & Licenses
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-psa-gold-400">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Phone
                  size={18}
                  className="mr-3 mt-1 flex-shrink-0 text-psa-gold-400"
                />
                <div>
                  <p className="text-gray-300">+88 01710-908697</p>
                  <p className="text-gray-300">+88 018132-27053</p>
                </div>
              </li>
              <li className="flex items-center">
                <Mail
                  size={18}
                  className="mr-3 flex-shrink-0 text-psa-gold-400"
                />
                <a
                  href="mailto:miahmasum04@gmail.com"
                  className="text-gray-300 hover:text-white transition duration-200"
                >
                  miahmasum04@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <MapPin
                  size={18}
                  className="mr-3 mt-1 flex-shrink-0 text-psa-gold-400"
                />
                <p className="text-gray-300">
                  888/1, Haji Ashraf Ali Super Market, East Shewrapara-Mirpur,
                  Dhaka-1216
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>
            © {currentYear} Professional Service Associates. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
